<div class="container">
    <div class="row justify-content-end mt-3 mr-2 align-items-center top-bar">
        <div class="legend-active"></div>
        <span class="legend-label mr-2 pl-1">Active</span>
        <div class="legend-incomplete"></div>
        <span class="legend-label mr-2 pl-1">Incomplete</span>
        <div class="legend-complete"></div>
        <span class="legend-label mr-3 pl-1">Completed</span>
        <div class="zooming-btn-container d-flex align-items-center">
            <button class="cxone-btn btn-md btn-secondary btn-bg-is-white" (click)="zoomIn()"
                [disabled]="treeScale == 1"> +
            </button>
            <svg class="icon-16 mx-2" id="action-btn-svg">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
            <button class="cxone-btn btn-md btn-secondary btn-bg-is-white" (click)="zoomOut()"
                [disabled]="treeScale < 0.8"> -
            </button>
        </div>
    </div>
    <div class="tree-container">
        <div class="mt-4 ml-3" [style.scale]="treeScale">
            <ng-container *ngIf="lines.length > 0">
                <ng-container *ngTemplateOutlet="List; context:{ item:lines}">
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
<ng-template #List let-lines="item">
    <ng-container *ngIf="lines && lines.length > 0">
        <draw-lines [lines]="lines" [id]="'line-'+lines[0]?.id" #drawLinesRef
            [constructedDrawLines]="drawLinesRefElements">
            <ng-container *ngFor="let item of lines; index as i">
                <ng-container>
                    <ng-container *ngIf="item.type === 'simple'" #simpleElement>
                        <ng-container *ngIf="item?.form?.nodeLabel && item?.form?.nodeLabel != ''">
                            <label [style.left.px]="item.elementPosition.x - 50"
                                [style.top.px]="item.elementPosition.y + 7"
                                class="node-label text-center absolute-position"
                                *ngIf="item?.form?.nodeLabelType != 'compare'"
                                [class.node-label-error]="!item?.form.isValid"
                                [class.node-label-success]="item?.form.isValid"
                                title="{{item?.form?.nodeLabel}}">{{item?.form?.nodeLabel}}</label>
                            <label *ngIf="item?.form?.nodeLabelType === 'compare'"
                                [style.left.px]="item.elementPosition.x + 33" id="compare-label"
                                [style.top.px]="item.elementPosition.y + 48"
                                class="node-label text-center absolute-position" title="{{item?.form?.nodeLabel}}"
                                [class.node-label-error]="!item?.form.isValid"
                                [class.node-label-success]="item?.form.isValid">{{item?.form?.nodeLabel}}</label>
                        </ng-container>
                        <div class="inpt p-1 absolute-position" [lineAnchor]="item?.id"
                            title="{{item?.form?.name || ''}}"
                            [class.inpt-active]="item?.id == dataFieldRef?.passDataToForms?.uniqueId"
                            [class.input-error]="item?.form?.isValid === false"
                            [class.input-success]="item?.form?.isValid === true" id="tree-{{item?.id}}"
                            [style.left.px]="item.elementPosition.x" [style.top.px]="item.elementPosition.y" #inputRef
                            (click)="setSelectedElement(i,item)">
                            {{item?.form?.name || ''}}</div>
                    </ng-container>
                    <ng-container *ngIf="item?.type === 'span'">
                        <div [lineAnchor]="item?.id" id="{{item?.id}}" class="link-div"
                            [style.left.px]="item.elementPosition.x + 1" [style.top.px]="item.elementPosition.y"
                            #inputRef>
                        </div>
                    </ng-container>
                </ng-container>
                <div *ngIf="item?.children?.length > 0">
                    <ng-container *ngTemplateOutlet="List; context:{ item:item?.children}"></ng-container>
                </div>
            </ng-container>
        </draw-lines>
    </ng-container>
</ng-template>

